import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import DatePicker from 'react-datepicker'
import { SecondaryButton } from 'components/Shared/Button'
import Input from 'components/Shared/Input'
import { useEvaluationModal } from './useEvaluationModal'
import { BACKHAUL_ATTRIBUTION_MODELS } from 'api/backhaulAttribution'

function EvaluationModalComponent({ packageId, backhaulAttribution, onEvaluationUpdated, onClose }) {
  const [date, setDate] = useState(undefined)
  const [model, setModel] = useState(BACKHAUL_ATTRIBUTION_MODELS.EVENTS_FROM_PACKAGE)
  const [attributionWindow, setAttributionWindow] = useState('')
  const { t } = useTranslation()

  const { handleSubmit, isLoading, options } = useEvaluationModal({
    packageId,
    onEvaluationUpdated,
    onClose,
  })

  useEffect(() => {
    if (!backhaulAttribution) {
      return
    }

    if (backhaulAttribution?.email_sent_date) {
      setDate(new Date(backhaulAttribution.email_sent_date))
    }

    if (backhaulAttribution?.backhaul_evaluation_attribution_window) {
      setAttributionWindow(String(backhaulAttribution.backhaul_evaluation_attribution_window))
    }

    if (backhaulAttribution?.backhaul_evaluation_model) {
      setModel(backhaulAttribution.backhaul_evaluation_model)
    }
  }, [backhaulAttribution])

  // return
  return (
    <div className="evaluation-modal-content">
      <div className="first-row">
        <div className="field-wrapper">
          <p className="label">{t('PackageBuilder.packageBuilderResults.evaluationModal.emailSendTime')}</p> 

          <div className="form-group input-cell input-cell--input input-cell--date separatePlaceholderBox ">
            <DatePicker
              selected={date} 
              onChange={(date) => setDate(date)} 
              dateFormat="dd.MM.yyyy"
              placeholderText={'DD.MM.YYYY'}
              popperPlacement={'bottom-start'}
              maxDate={new Date()}
            />
          </div>
        </div>

        <div className="field-wrapper">
          <p className="label">{t('PackageBuilder.packageBuilderResults.evaluationModal.attributionwindow')}</p>

          <div className="d-flex flex-row gap-2 align-items-center">
            <Input
              value={attributionWindow}
              name="attributionWindow"
              onChange={(e) => {
                const value = e.target.value
                if (value === '0') return
                setAttributionWindow(value)
              }}
              type="number"
              inputClass="days-input"
              min={1}
            />

            <p className="mb-0">{t('PackageBuilder.packageBuilderResults.evaluationModal.days')}</p>
          </div>
        </div>
      </div>

      <div className='field-wrapper'>
        <p className="label">{t('PackageBuilder.packageBuilderResults.evaluationModal.model')}</p>

        <div className="model-selector">
          {options.map((option) => (
            <button
              key={option.value}
              type="button"
              onClick={() => setModel(option.value)}
              className={`btn  ${model === option.value ? 'button--active' : ''}`}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>

      <div className="submit-button">
        <SecondaryButton
          text={t('PackageBuilder.packageBuilderResults.evaluationModal.submit')}
          disabled={!date || !attributionWindow || Number(attributionWindow) < 1 || !model || isLoading}
          onClick={() => {
            handleSubmit({ date, attributionWindow, model })
          }}
        /> 
      </div>
    </div>
  )
}

export default EvaluationModalComponent